import { render, staticRenderFns } from "./CreatePerson.vue?vue&type=template&id=5bc95b4c&"
import script from "./CreatePerson.vue?vue&type=script&lang=js&"
export * from "./CreatePerson.vue?vue&type=script&lang=js&"
import style0 from "./CreatePerson.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports